import React from 'react';
import { TwitterTweetEmbed } from 'react-twitter-embed';
import InstagramEmbed from 'react-instagram-embed';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Grid, Cell } from 'formlabs-web-components/Grid';

import TextPlugin from '../cms/TextPlugin';

import './SocialEmbed.module.css';

const SocialEmbedSection = ({
  body,
  embeds,
  social_embed_section_id,
  children,
  classes
}) => {
  const mediaembed = (
    <Cell largeSize={24}>
      <div styleName="embeds">
        {embeds.map(embed => {
          return (
            <div key={embed.id}>
              {embed.platform === 'twitter' && (
                <TwitterTweetEmbed
                  tweetId={embed.postid}
                  options={{ cards: 'hidden', width: '320' }}
                />
              )}
              {embed.platform === 'instagram' && (
                <InstagramEmbed
                  url={`https://www.instagram.com/p/${embed.postid}`}
                  maxWidth={320}
                  hideCaption={true}
                  containerTagName="div"
                  protocol=""
                  injectScript
                  onLoading={() => {}}
                  onSuccess={() => {}}
                  onAfterRender={() => {}}
                  onFailure={() => {}}
                />
              )}
            </div>
          );
        })}
      </div>
    </Cell>
  );

  return (
    <div
      id={social_embed_section_id}
      className={classes}
      style={{ marginTop: '6rem' }}
    >
      <div className="has-container">
        <Grid direction="x" primaryAlignment="align-center">
          <Cell largeSize={16}>
            <div className="mobile-padding" style={{ textAlign: 'center' }}>
              <TextPlugin body={body}>{children}</TextPlugin>
            </div>
          </Cell>
        </Grid>
        <Grid
          direction="x"
          primaryAlignment="align-center"
          styles={{ marginTop: '60px' }}
        >
          {mediaembed}
        </Grid>
      </div>
    </div>
  );
};

export default DisplayComponent(SocialEmbedSection);
